import React, { useEffect, useState, useMemo } from "react";
// import classes from "../../assets/styles/Pages/CouponManagement/CouponManagement.module.css";
import { useAtom } from "jotai";
import { loggedInUser, teamIDCheck } from "../../utils/store";
import Loader from "../../components/Loader";
import "react-datepicker/dist/react-datepicker.css";
import { get, post } from "../../server";
import { LEADS, EXPORT_LEAD, IMPORT_LEAD } from "../../utils/constants/apiUrl";
import showToast from "../../helpers/showToast";
import { Link } from "react-router-dom";
import DataTable, { createTheme } from "react-data-table-component";
import { BsThreeDotsVertical } from "react-icons/bs";
import { useParams } from "react-router-dom";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import { trackEvent } from "../../utils/mixpanel";
import { Button } from "react-bootstrap";
import { TbFileExport } from "react-icons/tb";
const Leads = () => {
  const [loggedUser, setLoggedUser] = useAtom(loggedInUser);
  const [userTeamId, setUserTeamId] = useAtom(teamIDCheck);
  const [loading, setLoading] = useState(false);
  const [filterText, setFilterText] = useState("");
  const [errors, setErrors] = useState({});
  const [leads, setLeads] = useState([]);
  const [exportLeads, setExportLeads] = useState();
  const [activeTab, setActiveTab] = useState("all");
  let { id } = useParams();
  const handleFilter = (e) => {
    setFilterText(e.target.value);
  };

  const exportAllLeads = async (id) => {
    setLoading(true);
    const queryString = `?id=${id}`;
    let { status, message, data } = await get(
      id ? EXPORT_LEAD + queryString : EXPORT_LEAD,
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );
    if (status) {
      const filePath = data.path;
      saveAs(filePath, "leads.xlsx");
    } else {
      showToast(status, message);
    }
    setLoading(false);
  };

  const importLead = async (rowId) => {
    setLoading(true);
    const payload = {
      id: rowId,
    };
    let { status, message, data } = await post(
      IMPORT_LEAD,
      payload,
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );
    if (status) {
      await loadAllLeads();
    } else {
      showToast(status, message);
    }
    setLoading(false);
  };
  const loadAllLeads = async (lead_type) => {
    setLoading(true);
    // const queryString = `?team_id=${userTeamId}&lead_type=${lead_type}`;
    // const leadQueryString = `?lead_type=${lead_type}`;
    const queryString = userTeamId
      ? `?team_id=${userTeamId}&lead_type=${lead_type}`
      : `?lead_type=${lead_type}`;
    const url = LEADS + queryString;
    let { status, message, data } = await get(
      url,
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );
    if (status) {
      setLeads(data);
    } else {
      showToast(status, message);
    }
    setLoading(false);
  };

  const handleTabChange = (selectedTab) => {
    setActiveTab(selectedTab);
    loadAllLeads(selectedTab);
  };

  const filteredItems = useMemo(() => {
    const filtered = leads.filter(
      (item) =>
        `${item.name || ""}`.toLowerCase().includes(filterText.toLowerCase()) ||
        `${item.email || ""}`.includes(filterText)
    );

    return filtered;
  }, [filterText, leads]);

  const formatText = (text) => {
    const words = text.split("_");
    const capitalizedWords = words.map(
      (word) => word.charAt(0).toUpperCase() + word.slice(1)
    );

    return capitalizedWords.join(" ");
  };

  createTheme(
    "solarized",
    {
      background: {
        default: "background: var(--secondary_color)",
      },
    },
    "dark"
  );
  const getFormData = (row, field_type) => {
    const userLeadData = row.userLeadData || [];
    const formData = userLeadData.find(
      (item) => item.field_type === field_type
    );
    return formData ? formData.data : "-";
  };

  const columns = [
    {
      name: "Full Name",
      cell: (row) => (
        <>
          {getFormData(row, "first_name")} {getFormData(row, "last_name")}
        </>
      ),
    },
    {
      name: "Email",
      cell: (row) => getFormData(row, "email"),
    },
    // {
    //   name: "Phone no",
    //   cell: (row) => (
    //     <a
    //       href={`tel:${getFormData(row, "Contact Number")}`}
    //       className="globalDetail"
    //       style={{ display: "block" }}
    //     >
    //       {getFormData(row, "Contact Number")}
    //     </a>
    //   ),
    // },
    {
      name: "Company",
      cell: (row) => getFormData(row, "company"),
    },
    // {
    //   name: "Location",
    //   cell: (row) => (
    //     <p className="globalDetail">{getFormData(row, "Location")}</p>
    //   ),
    // },
    {
      name: "",
      center: true,
      cell: (row) =>
        row.is_imported === 1 ? (
          <span className="saved">Saved</span>
        ) : (
          <Button
            variant="outline-primary"
            className="primary_button"
            onClick={() => {
              trackEvent("Import Collection Clicked", {
                collection_id: row.id,
                collection_name: row.name, // optional, if available
                source: window.location.pathname, // helpful to track which page this happened on
              });
              importLead(row.id);
            }}
          >
            Import
          </Button>
        ),
    },
    {
      name: "Action",
      width: "10%",
      right: "true",
      cell: (row) => (
        <div className="action">
          <button
            className="btn customActionDropdown dropdown-toggle"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <BsThreeDotsVertical className={"globalVerticalThreeDots"} />
          </button>
          <ul className="customActionDropdownMenu dropdown-menu dropdown-menu-end ">
            <li>
              <Link
                className="dropdown-item"
                to={`viewLead/${row.id}`}
                onClick={() => {
                  trackEvent("View Lead Clicked", {
                    ...row,
                    source: window.location.pathname,
                  });
                }}
              >
                View
              </Link>
            </li>
            <li>
              <button
                className="dropdown-item"
                onClick={() => {
                  trackEvent("Export Collection Clicked", {
                    lead_id: row.id,
                    ...row,
                    source: window.location.pathname,
                  });
                  exportAllLeads(row.id);
                }}
              >
                Export Collection
              </button>
            </li>
            {/* <li>
              <Link
                className="dropdown-item"
                to="#"
                style={{ color: "#E35252" }}
                onClick={() => handleDelete(row.id)}
              >
                Delete
              </Link>
            </li> */}
          </ul>
        </div>
      ),
    },
  ];

  useEffect(() => {
    loadAllLeads("all");
  }, []);

  return (
    <>
      {!loading ? (
        <div>
          <div className="row align-items-center justify-content-between mb-4">
            <div className="col-12 col-md-6">
              <div className="heading">
                <h1 className="mb-md-0">
                  Leads <span>({leads.length})</span>
                </h1>
              </div>
            </div>
            <div className="col-12 col-md-6 text-end">
              {!loading && leads.length > 0 && (
                <Button
                  variant="outline-primary"
                  className="primary_button"
                  onClick={() => {
                    trackEvent("Export All Leads", {
                      total_leads: leads.length,
                      leads_data: leads,
                      source: window.location.pathname,
                    });
                    exportAllLeads();
                  }}
                >
                  <TbFileExport className="me-1" /> Export Collection
                </Button>
              )}
            </div>
          </div>
          <div className="">
            <div className="tabsWrapper">
              <Tabs
                defaultActiveKey="all"
                activeKey={activeTab}
                className="customSubscriptionTabs"
                transition={false}
                onSelect={handleTabChange}
              >
                <Tab eventKey="all" title="All Leads">
                  <div className="default-list-table">
                    <DataTable
                      columns={columns}
                      data={filteredItems}
                      pagination
                    />
                  </div>
                </Tab>
                <Tab eventKey="new" title="New">
                  <div className="default-list-table">
                    <DataTable
                      columns={columns}
                      data={filteredItems}
                      pagination
                    />
                  </div>
                </Tab>
                <Tab eventKey="imported" title="Archive">
                  <div className="default-list-table">
                    <DataTable
                      columns={columns}
                      data={filteredItems}
                      pagination
                    />
                  </div>
                </Tab>
              </Tabs>
            </div>
          </div>
        </div>
      ) : (
        <Loader />
      )}
    </>
  );
};

export default Leads;
